/**
 * Caches normalized subjects for one sort or Jump To pass. Search results repeat subjects across
 * replies, so each distinct subject is normalized once. Create a new cache per operation so
 * localized prefixes are not held across language changes.
 */
export default function createSubjectCache(normalizeSubject: (subject: string) => string): (subject: string | null | undefined) => string {
    const normalizedSubjects = new Map<string, string>();
    return subject => {
        const key = subject ?? "";
        let normalized = normalizedSubjects.get(key);
        if (normalized === undefined) {
            normalized = normalizeSubject(key);
            normalizedSubjects.set(key, normalized);
        }
        return normalized;
    };
}
